export enum TIME {
  MILLISECONDS = 1,
  SECONDS = 1000,
  MINUTES = 60000,
  HOURS = 3600000
}
